import type { ISpread } from "../../spreadsSlice";

export const celticCrossSpread: ISpread = {
  id: "spread_celtic_cross",
  name: "Кельтский крест",
  altNames: ["Celtic Cross"],
  purpose:
    "Глубокий многоплановый анализ ситуации: внутреннего состояния, внешних влияний, скрытых мотиваций и вероятного исхода.",
  cardsCount: 10,
  layout: `    [5]
    [3][1][4]
      [2]
      [6]
      [7]
      [8]
      [9]
      [10]`,
  positions: [
    {
      id: "situation",
      title: "Суть ситуации",
      meaning: "Что сейчас находится в центре внимания.",
    },
    {
      id: "crossing",
      title: "Перекрестное влияние / препятствие",
      meaning: "Что помогает или мешает развитию ситуации.",
    },
    {
      id: "foundation",
      title: "Основа / корень",
      meaning: "Глубинные причины и фундамент ситуации.",
    },
    {
      id: "past",
      title: "Прошлое",
      meaning: "События и влияния, которые привели к текущему состоянию.",
    },
    {
      id: "conscious",
      title: "Сознание / устремление",
      meaning: "Мысли, цели и то, что осознаётся.",
    },
    {
      id: "near_future",
      title: "Ближайшее будущее",
      meaning: "Ближайшее вероятное развитие ситуации.",
    },
    {
      id: "self_attitude",
      title: "Ваше отношение",
      meaning: "Внутреннее состояние и восприятие ситуации.",
    },
    {
      id: "external_influences",
      title: "Внешние влияния",
      meaning: "Окружение, другие люди и внешние события.",
    },
    {
      id: "hopes_fears",
      title: "Надежды и страхи",
      meaning: "Скрытые мотивы, ожидания, надежды и опасения.",
    },
    {
      id: "outcome",
      title: "Итог",
      meaning: "Вероятный исход и направление развития ситуации.",
    },
  ],
  symbolism:
    "Центральный крест показывает точку напряжения и выбора, пересечение осознаваемого и неосознаваемого; вертикальный посох отражает личный путь и развитие ситуации.",
  archetypes: [
    "Крест",
    "Пересечение сознательного и бессознательного",
    "Личный путь",
  ],
  psychology:
    "Помогает понять взаимодействие внутренних установок и внешних обстоятельств, выявить конфликт сознательных намерений и бессознательных импульсов и увидеть направление развития.",
  procedure: {
    preparation:
      "Сформулировать чёткий содержательный вопрос и тщательно перетасовать колоду.",
    steps:
      "Выкладывать карты по порядку 1–10, называя каждую позицию; сначала читать центральный крест, затем вертикальный посох; после отдельных позиций анализировать их взаимосвязи.",
  },
  interpretations: [
    "Позиция 2 может показывать как препятствие, так и ресурс.",
    "Позиции 9 и 10 следует сопоставлять: надежды и страхи могут существенно влиять на вероятный итог.",
    "Позиции основы и прошлого помогают понять причины текущей динамики.",
  ],
  nuances: [
    "Начинать интерпретацию следует с центрального креста.",
    "Не игнорировать позиции основы и прошлого.",
    "Итог следует читать как вероятное направление, связанное со всей структурой расклада.",
  ],
  examples: [
    {
      cards: [
        "5 Жезлов",
        "Сила",
        "4 Пентаклей",
        "6 Мечей",
        "Императрица",
        "Колесо Фортуны",
        "Повешенный",
        "Жрица",
        "Луна",
        "Солнце",
      ],
      interpretation:
        "Конфликтная ситуация с возможностью конструктивного преодоления; страх потери и прошлый уход от конфликта сочетаются со стремлением к стабильности, а дальнейшие перемены могут привести к более ясному исходу.",
    },
  ],
  selfQuestions: [
    "Какая скрытая динамика влияет на моё решение?",
    "Что я боюсь отпустить?",
    "Как соединить мои надежды и реальность?",
  ],
};

